/*global VXConfig */
import Constants from '../Constants';
import { doFetch } from '../../utils/CommonUtils';
import Routes from '../../utils/Routes';
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';

const CHANGE_EVENTS = {
	//	StatusBar: 'statusBarChange',
	Teasers: 'teasersChange',
};

const _teasers = {};

/**
 * Find a mobile teaser config by its id
 * @param teaserId
 * @returns {*|null}
 */
function findConfigById(teaserId) {
	const teasers = window.VXBannerConfig ? { ALL: window.VXBannerConfig } : _teasers;

	for (const key in teasers) {
		for (const category in teasers[key]) {
			const config = teasers[key][category].find((item) => item.id === teaserId);
			if (config) {
				return config;
			}
		}
	}
	return null;
}

const TeaserStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: CHANGE_EVENTS,

	_getTeasers: function (routeName, routeArgs) {
		const key = getTeaserCacheKey(routeName, routeArgs);
		return typeof _teasers[key] !== 'undefined' ? _teasers[key] : null;
	},

	_hasTeasers: function (routeName, routeArgs) {
		const teasers = TeaserStore._getTeasers(routeName, routeArgs);
		return teasers !== null && teasers.constructor === Object && Object.keys(teasers).length > 0;
	},
	getPrivateShopDiscountMobileBannerUrl: function () {
		return VXConfig.privateShopDiscountMobileBannerUrl;
	},
	getTeaserConfigById: function (teaserId) {
		return findConfigById(teaserId);
	},
	getFeedbackFeatureByTeaserId: function (id) {
		const bannerConfig = TeaserStore.getTeaserConfigById(id);
		const featureFeedback = bannerConfig?.addons?.FeatureFeedback;
		return featureFeedback || undefined;
	},
	loadTeasers(routeName, routeArgs) {
		const key = getTeaserCacheKey(routeName, routeArgs);
		if (_teasers[key] !== undefined) {
			// Teasers already loaded, no need to fetch again
			return;
		}

		_teasers[key] = {};

		if (VXConfig.teaser?.teaser && VXConfig.teaser.key === key) {
			_teasers[VXConfig.teaser.key] = VXConfig.teaser.teaser;
			TeaserStore.emit(CHANGE_EVENTS.Teasers);
		} else {
			doFetch(
				Routes.getRoute(Routes.Names.TEASER),
				{
					routeName,
					routeArgs,
				},
				Constants.HttpMethods.POST,
				true,
			).then((result) => {
				if (result) {
					_teasers[key] = result.data;
					TeaserStore.emit(CHANGE_EVENTS.Teasers);
				}
			});
		}
	},
});

/**
 *
 * @param {String} routeName
 * @param {Object} routeArgs
 * @returns {string}
 */
function getTeaserCacheKey(routeName, routeArgs) {
	return routeName + ':' + JSON.stringify(routeArgs);
}

export default TeaserStore;
